<template>
  <layout2>
    <!-- BREADCRUMB -->
    <div class="container py-3">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-0 bg-transparent p-0">
          <li class="breadcrumb-item">
            <router-link to="/" class="text-muted">Trang chủ</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/tin-tuc" class="text-muted">Tin tức</router-link>
          </li>
          <li class="breadcrumb-item active text-primary text-truncate" style="max-width: 400px">
            <!--            {{ post.title }}-->
          </li>
        </ol>
      </nav>
    </div>

    <!-- MAIN CONTENT -->
    <section class="news-detail-section py-5">
      <div class="container">
        <div class="row g-5">
          <!-- LEFT: BÀI VIẾT CHI TIẾT -->
          <div class="col-lg-8">
            <article class="news-article bg-white rounded-4 shadow-lg overflow-hidden">
              <!-- HÌNH ẢNH CHÍNH -->
              <div class="featured-image-wrapper position-relative">
                <img :src="url + post.fileImage.fileId" :alt="post.name" class="featured-image w-100" loading="lazy" />
                <div class="image-overlay">
                  <!-- Overlay mờ -->
                </div>
                <div class="category-badge position-absolute start-4 bottom-4 mb-2 m-lg-2">
                  <span class="badge bg-primary text-white px-3 py-2 rounded-pill shadow-sm">
                    {{ post.menu.name ? post.menu.name : "Tin tức" }}
                  </span>
                </div>
              </div>

              <!-- NỘI DUNG -->
              <div class="article-body p-4 p-md-5">
                <h1 class="article-title display-5 fw-bold text-dark mb-4">
                  {{ post.name }}
                </h1>

                <div class="article-meta d-flex flex-wrap align-items-center gap-3 text-muted mb-4">
                  <span class="d-flex align-items-center gap-1">
                    <i class="mdi mdi-calendar text-primary"></i>
                    {{ formatDate(post.publicationDateShow) }}
                  </span>
                  <span v-if="post.view" class="d-flex align-items-center gap-1">
                    <i class="mdi mdi-eye text-primary"></i>
                    {{ post.views || 0 }} lượt xem
                  </span>
                  <span class="d-flex align-items-center gap-1" v-if="post.nameAuthor">
                    <i class="mdi mdi-account text-primary"></i>
                    {{ post.nameAuthor }}
                  </span>
                </div>

                <div class="article-content prose prose-lg max-w-none" v-html="post.content"></div>

                <!-- <div
                  class="article-tags mt-5 pt-4 border-top"
                  v-if="post.tags && post.tags.length"
                >
                  <div class="d-flex flex-wrap gap-2">
                    <span
                      v-for="tag in post.tags"
                      :key="tag"
                      class="badge bg-light text-dark border px-3 py-2 rounded-pill"
                    >
                      #{{ tag }}
                    </span>
                  </div>
                </div> -->

                <div class="share-section mt-5 pt-4 border-top">
                  <p class="fw-bold mb-3">Chia sẻ bài viết:</p>
                  <div class="share-buttons d-flex gap-2">
                    <a :href="fbShare" target="_blank" class="btn btn-fb btn-sm">
                      <i class="fab fa-facebook-f"></i>
                    </a>

                    <button @click="copyLink" class="btn btn-copy btn-sm">
                      <i class="mdi mdi-link-variant"></i>
                    </button>
                  </div>
                </div>
              </div>
            </article>
          </div>

          <!-- RIGHT: SIDEBAR -->
          <div class="col-lg-4">
            <aside class="related-news-sidebar sticky-top" style="top: 100px">
              <!-- BÀI VIẾT NỔI BẬT (CAROUSEL) -->
              <div class="featured-posts mb-5">
                <h5 class="fw-bold text-primary mb-3 position-relative d-inline-block">
                  Bài viết liên quan
                  <span class="underline"></span>
                </h5>
                <VueSlickCarousel v-bind="featuredSettings" class="featured-carousel">
                  <div v-for="item in relatedPosts" :key="item._id" class="px-2">
                    <router-link :to="{ path: `/tin-tuc/chi-tiet/${item._id}` }" class="text-decoration-none">
                      <div class="featured-card bg-white rounded-3 shadow-sm overflow-hidden hover-lift">
                        <img :src="url + post.fileImage.fileId" :alt="item.name" class="featured-image w-100"
                          style="height: 110px; object-fit: cover" loading="lazy" />
                        <div class="p-3">
                          <h6 class="featured-title mb-1 line-clamp-2 text-dark fw-600">
                            {{ item.name }}
                          </h6>
                          <small class="text-muted">
                            <i class="mdi mdi-calendar"></i>
                            {{ formatDate(item.publicationDateShow) }}
                          </small>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </VueSlickCarousel>
              </div>

              <!-- TIN LIÊN QUAN -->
            </aside>
          </div>
        </div>
      </div>
    </section>
  </layout2>
</template>

<script>
import Layout2 from "@/layouts/layout.vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import moment from "moment";
import { tinTucModel } from "@/models/profession/tinTuc/tinTucModel";
import { formatDate } from "@/utils/time/dateUtils.js";

export default {
  name: "DetailNews",
  components: { Layout2, VueSlickCarousel },

  watch: {
    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        // Tạm dùng dữ liệu mẫu, không gọi API
        this.relatedPosts = this.relatedPosts.slice(0, this.perPage);
      }
    },
    "$route.params.id": {
      immediate: true,
      handler(newId, oldId) {
        if (newId !== oldId) {
          // 1. Gọi lại hàm lấy chi tiết bài viết mới
          this.getDetails();
          // 2. Gọi lại hàm lấy bài viết liên quan cho bài mới
          this.fetchRelatedPosts();

          // (Tùy chọn) Cuộn lên đầu trang sau khi chuyển bài
          window.scrollTo(0, 0);
        }
      },
    },
  },
  created() {
    this.getDetails();
    this.fetchRelatedPosts();
  },
  methods: {
    async getDetails() {
      this.isLoading = true;
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
      });

      await this.$store
        .dispatch("profession/tinTuc/tinTucStore/getById", {
          _id: this.$route.params.id,
        })
        .then((res) => {
          if (res.code === 0) {
            console.log("log", res.data);
            this.post = res.data;
            document.title = `${this.post.name} - Lễ hội trái cây tỉnh Đồng Tháp`;
            loader.hide();
          } else {
            loader.hide();
            this.$store.dispatch("snackBarStore/addNotify", {
              data: {
                code: res.code,
                message: res.message,
              },
            });
          }
        });
    },

    async fetchRelatedPosts() {
      const params = {
        _id: this.$route.params.id,
      };
      try {
        const res = await this.$store.dispatch(
          "profession/tinTuc/tinTucStore/newsLienQuan",
          params
        );
        this.relatedPosts = res.data.data;
        this.totalRelated = res.data.totalRows;
      } catch (err) {
        console.error("Fetch Related post: ", err);
      }
    },
    // async incrementView(id) {
    //   try {
    //     await this.$store.dispatch('tinTucStore/incrementView', id)
    //   } catch (err) {
    //
    //   }
    // },

    copyLink() {
      navigator.clipboard.writeText(this.currentUrl);
      this.$notify({
        type: "success",
        text: "Đã sao chép liên kết!",
      });
    },
  },
  computed: {
    fbShare() {
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        this.currentUrl
      )}`;
    },
    totalPages() {
      return Math.ceil(this.totalRelated / this.perPage);
    },
    currentUrl() {
      return window.location.href;
    },
  },
  data() {
    return {
      url: `${process.env.VUE_APP_API_URL}filesminio/view/`,
      apiView: `${process.env.VUE_APP_API_URL}filesminio/view/`,
      // === Fake Post Detail ===
      post: null,

      // === Fake Featured Posts ===
      // === BÀI VIẾT NỔI BẬT (Carousel) ===
      featuredPosts: [],

      // === TIN LIÊN QUAN (Danh sách + phân trang) ===
      relatedPosts: [],
      formatDate: formatDate,
      // === PHÂN TRANG ===
      totalRows: 1,
      numberOfElement: 1,
      perPage: 12,
      currentPage: 1,

      sortBy: "age",
      sortDesc: true,
      totalRelated: 1, // Giả lập có 12 bài liên quan

      featuredSettings: {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        cssEase: "ease-in-out",
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true,
            },
          },
        ],
      },
    };
  },
};
</script>

<style scoped>
/* ===============================
   ARTICLE MAIN WRAPPER
================================*/
.news-article {
  border-radius: 1rem;
  overflow: hidden;
  background: #fff;
}

/* ===============================
   FEATURED IMAGE (ẢNH BÀI VIẾT)
================================*/
.featured-image-wrapper {
  position: relative;
  height: 360px;
  overflow: hidden;
}

.featured-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;
}

.featured-image-wrapper:hover .featured-image {
  transform: scale(1.05);
}

/* overlay mờ để tăng tương phản */
.image-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.35));
}

/* Category badge */
.category-badge {
  left: 20px;
}

/* ===============================
   ARTICLE BODY
================================*/
.article-body {
  background: #fff;
}

/* Title */
.article-title {
  font-family: var(--font-serif, "Merriweather", serif);
  font-size: 1.9rem !important;
}

/* Meta info */
.article-meta i {
  font-size: 1.2rem;
}

.article-meta span {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* ===============================
   ARTICLE CONTENT (HTML)
   Hiển thị nội dung bài viết
================================*/
.article-content {
  font-size: 1.15rem;
  line-height: 1.9;
  color: #333;
  font-family: var(--font-sans, "Inter", sans-serif);
}

.article-content p {
  margin-bottom: 1.35rem;
}

.article-content h2,
.article-content h3,
.article-content h4 {
  font-family: var(--font-serif);
  margin-top: 2rem;
  margin-bottom: 1rem;
  color: #222;
}

.article-content ul,
.article-content ol {
  margin: 1.2rem 0 1.2rem 1.2rem;
  line-height: 1.8;
}

.article-content blockquote {
  border-left: 4px solid #0d6efd;
  padding-left: 1rem;
  margin: 1.8rem 0;
  font-style: italic;
  color: #555;
}

/* ===============================
   ARTICLE TAGS
================================*/
.article-tags .badge {
  font-size: 0.9rem;
  background: #f5f5f5 !important;
  border: 1px solid #ddd !important;
  cursor: pointer;
  transition: all 0.2s;
}

.article-tags .badge:hover {
  background: #eaeaea !important;
}

/* ===============================
   SHARE SECTION
================================*/
.share-buttons .btn {
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-fb {
  background: #1877f2;
  color: white;
}

.btn-copy {
  background: #eaeaea;
  color: #444;
}

.btn-copy:hover {
  background: #d5d5d5;
}

/* ===============================
   SIDEBAR
================================*/
.related-news-sidebar {
  position: sticky;
  top: 100px;
}

.underline {
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 40px;
  height: 3px;
  background: var(--bs-primary);
  border-radius: 4px;
}

/* FEATURED POSTS CAROUSEL */
.featured-card {
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.featured-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.featured-title {
  font-family: var(--font-sans);
  font-size: 0.95rem;
}

/* ===============================
   RELATED NEWS LIST
================================*/
.related-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.related-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
}

.related-thumb {
  width: 90px;
  height: 70px;
  border-radius: 0.5rem;
  overflow: hidden;
}

/* ===============================
   PAGINATION
================================*/
.custom-pagination .page-item.active .page-link {
  background: var(--bs-primary);
  border-color: var(--bs-primary);
  color: #fff;
}

.custom-pagination .page-link {
  border-radius: 8px;
  font-size: 0.85rem;
}

/* ===============================
   RESPONSIVE
================================*/
@media (max-width: 768px) {
  .featured-image-wrapper {
    height: 180px;
  }

  .article-title {
    font-size: 1.6rem;
  }

  .related-thumb {
    width: 70px;
    height: 60px;
  }
}

:deep(.article-content figure.image) {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

:deep(.article-content figure.image img) {
  margin: 0 auto !important;
  display: block !important;
  border-radius: 8px;
  width: 80%;
}
</style>
